export const business = {
  name: "Flexhire Solutions LLC",
  phoneDisplay: "+1 614-382-9458",
  phoneShort: "614-382-9458",
  phoneHref: "tel:+16143829458",
  whatsappHref: "https://wa.me/16143829458",
  email: "aleziwinder20@gmail.com",
  emailHref: "mailto:aleziwinder20@gmail.com?subject=Flexhire%20Solutions",
  website: "www.flexhiresolutionsllc.com",
  websiteUrl: "https://www.flexhiresolutionsllc.com",
  street: "3431 Cleveland Ave",
  plaza: "Northern Lights Shopping Center",
  city: "Columbus",
  region: "OH",
  postalCode: "43224",
  hours: "7:00 AM – 5:00 PM",
  rating: "5.0",
  reviewCount: 8,
  googleReviewsUrl: "https://www.google.com/search?q=Flexhire+Solutions+LLC+Columbus+Ohio+reviews",
  mapsUrl: "https://www.google.com/maps/place/flexhire+solutions+llc/@40.0375789,-82.9684844,17z",
  mapEmbedUrl: "https://www.google.com/maps?q=Flexhire+Solutions+LLC,+3431+Cleveland+Ave,+Columbus,+OH+43224&z=16&output=embed",
  heroImage: "https://cdn.magicpatterns.com/uploads/1kV7hXU2LdHg69iUJYSvUF/Banner_Flexhire.jpg",
};
